<template>
  <div class="popUpWrap">
    <section class="popup dark" style="max-width: 480px">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close"/>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t('organization-transfer-of-role-title') }}</h5>
          <p><span class="red">{{ t('organization-transfer-of-role-description') }}</span></p>
        </div>
        <ul style="margin-top: 24px">
          <li>
            <input type="checkbox" id="check1" v-model="isAgree">
            <label for="check1">{{ t('organization-transfer-of-role-info') }}</label>
          </li>
        </ul>
        <div class="btnArea" style="margin-top: 16px">
          <button :class="{ disabled: !isAgree }" @click.stop="onClickTransferAuthoritySuperAdmin">
            {{ t('organization-transfer-of-role-button-2') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { useToastStore } from "~/store/toast/toastStore";
import { ToastType } from "~/components/Common/Toast/model/ToastType";
import { useRouter } from "#imports";
import { useOrganizationService } from "~/composables/service/useOrganizationService";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";

const { t } = useI18n();
const { $i18n } = useNuxtApp();
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const organizationService = useOrganizationService();

const router = useRouter()

const isAgree = ref(false)

const onClickTransferAuthoritySuperAdmin = () => {
  if(!isAgree.value) return;

  const uuid = dialogStore.options.props.uuid ?? "";

  organizationService.updateOrganizationMemberRole(
    uuid,
    UserV2Type.ORG_SUPER_ADMINISTRATOR,
    undefined
  ).then((isSuccess: boolean) => {
    if(isSuccess) handlerSuccess();
    else handlerFail();
  }).catch(handlerFail);
}

const handlerSuccess = () => {
  toastStore.openToast({
    toastType: ToastType.SUCCESS,
    contents: t("organization-transfer-of-role-success"),
  });
  dialogStore.options.confirm?.event();
  dialogStore.close();
}

const handlerFail = () => {
  toastStore.openToast({
    toastType: ToastType.FAILED,
    contents: t("organization-transfer-of-role-fail"),
  });
}
</script>
